import { HTTP_TOKEN } from "./http";

export const getContacts = (params) => {
  return HTTP_TOKEN.get("contact", { params }).then((result) => {
    return result.data;
  });
};

export const createContact = (data) => {
  return HTTP_TOKEN.post("contact", data).then((result) => {
    return result.data;
  });
};

export const getContact = (contact_id, data) => {
  return HTTP_TOKEN.get(`contact/${contact_id}`, data).then((result) => {
    return result.data;
  });
};



export const updateContact = (contact_id, data) => {
  return HTTP_TOKEN.put(`contact/${contact_id}`, data).then((result) => {
    return result.data;
  });
};

export const removeContact = (contact_id) => {
  return HTTP_TOKEN.delete(`contact/${contact_id}`).then((result) => {
    return result.data;
  });
};
